import { MatPaginatorIntl } from '@angular/material/paginator';
import {AfterViewInit, Injectable, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {ILanguages} from '../../models/languages.interface';
import {select, Store} from '@ngrx/store';
import {IAppState} from '../../store/state/app.state';
import {selectLanguages} from '../../store/selectors/languages.selectors';
import {IIdentify} from '../../models/identify.interface';
import {selectIdentify} from '../../store/selectors/identify.selectors';


@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
    translate: TranslateService;
    itemsPerPageLabel = 'Items per page';
    nextPageLabel     = 'Next page';
    previousPageLabel = 'Previous page';
    of = 'of';
    getRangeLabel = function (page, pageSize, length) {

        this.translate.get([
            'GENERAL.OF'
        ])
            .subscribe((translation: any) => {
                this.of = translation['GENERAL.OF'];
            });

        if (length === 0 || pageSize === 0) {
            return '0 ' + this.of + ' ' + length;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
        return startIndex + 1 + ' - ' + endIndex + ' ' + this.of + ' ' + length;
    };

    injectTranslateService(translate: TranslateService) {
        this.translate = translate;

        this.translate.onLangChange.subscribe(() => {
            this.translateLabels();
        });

        this.translateLabels();
    }

    translateLabels() {

        this.translate.get([
            'GENERAL.ITEMS_PAGE',
            'GENERAL.NEXT',
            'GENERAL.PREV'
        ])
            .subscribe((translation: any) => {
                this.itemsPerPageLabel = translation['GENERAL.ITEMS_PAGE'];
                this.nextPageLabel = translation['GENERAL.NEXT'];
                this.previousPageLabel = translation['GENERAL.PREV'];

                this.changes.next();
            });
    }
}